export const config = {
  title: "Cathy Walker | ERA Realestate | Sandy, UT",
  meta: {
    description:
      "Cathy Walker, professional real estate agent with ERA Brokers Consolidated in Sandy, Utah. Specializing in residential homes, buyer and seller representation, and property investment in Salt Lake County and surrounding areas.",
    keywords: [
      "Cathy Walker Realtor",
      "ERA Realestate Sandy Utah",
      "Sandy UT Real Estate",
      "Salt Lake County Homes",
      "Utah Real Estate Agent",
      "Buy Home Sandy UT",
      "Sell Home Utah",
      "Residential Real Estate",
      "ERA Brokers Consolidated"
    ],
    author: "Cathy Walker",
    canonicalUrl: "https://www.cathywalkerhomes.com/",
  },
  sections: {
    header: {
      businessName: "Cathy Walker",
    },
    sectionB: {
      heroTitle: "Your Trusted Real Estate Partner in Sandy",
      heroSubtitle: "Expert Guidance for Buying & Selling Homes in Utah",
      learnAboutText: "Get Started Today",
      phoneNumber: "3852509323",
      phoneLabel: "(385) 250-9323",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop",
      cardData: [
        {
          title: "Home Buying",
          description:
            "Expert assistance to find your perfect home in Sandy and throughout Salt Lake County.",
        },
        {
          title: "Home Selling",
          description:
            "Strategic marketing and negotiation to get the best price for your property.",
        },
        {
          title: "Investment Properties",
          description:
            "Professional guidance for real estate investors looking to grow their portfolio.",
        },
      ],
      description:
        "Cathy Walker is a dedicated real estate professional with ERA Brokers Consolidated in Sandy, Utah. With extensive knowledge of the local market and a commitment to exceptional service, Cathy helps clients achieve their real estate goals.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "Comprehensive real estate solutions for buyers, sellers, and investors throughout Sandy and Salt Lake County.",
      cards: [
        {
          title: "Buyer Representation",
          description:
            "Personalized home search assistance, market insights, and expert negotiation to help you find and secure your dream home.",
          imageSrc: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format&fit=crop",
          imageAlt: "Home Buying Services",
        },
        {
          title: "Seller Representation",
          description:
            "Professional home staging advice, competitive market analysis, and powerful marketing strategies to sell your home for top dollar.",
          imageSrc: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=1996&auto=format&fit=crop",
          imageAlt: "Home Selling Services",
        },
        {
          title: "Market Expertise",
          description:
            "In-depth knowledge of Sandy, Salt Lake County, and surrounding Utah communities to provide accurate market analysis and pricing.",
          imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Real Estate Market Analysis",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "First-Time Homebuyer Programs",
        "Relocation Assistance",
        "Investment Property Consultation",
        "New Construction Homes",
        "Luxury Home Marketing",
      ],
    },
    sectionD: {
      aboutTitle: "About Cathy Walker",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/73/2405973_normal.jpg",
        alt: "Cathy Walker - ERA Realtor",
      },
      aboutText: [
        "Cathy Walker is a professional real estate agent affiliated with ERA Brokers Consolidated, one of Utah's most respected real estate firms. Based in Sandy, Utah, Cathy brings dedication, local expertise, and personalized service to every client relationship.",
        "Whether you're buying your first home, selling your current property, upgrading to a larger space, or investing in real estate, Cathy provides the guidance and support you need. Her commitment to understanding your unique needs and goals ensures a smooth, successful real estate experience from start to finish.",
      ],
    },
    sectionE: {
      profileImage: "https://images.marketleader.com/Logos/35/922035_normal.png",
      profileAlt: "Cathy Walker - Real Estate Agent",
      businessName: "Cathy Walker - ERA Realestate",
      contact: {
        phone: "3852509323",
        phoneLabel: "(385) 250-9323",
        email: "cathylynnwalker@gmail.com",
        website: "https://www.cathywalkerhomes.com/",
        address: "150 East St #410, Sandy, UT 84070",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "150 East St #410, Sandy, UT 84070",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3027.8!2d-111.8835!3d40.5775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87528b8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2s150%20E%20St%20%23410%2C%20Sandy%2C%20UT%2084070!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;